import React from "react";
import Icon1 from "../../images/icon-1.svg";
import Icon2 from "../../images/icon-2.svg";
import Icon3 from "../../images/icon-3.svg";

import {
  ServicesContainer,
  ServicesH1,
  ServicesH2,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesP,
} from "./ServicesElements";

const Services = () => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>How does it work?</ServicesH1>
      <ServicesWrapper>
        <ServicesCard>
          <ServicesIcon src={Icon1} />
          <ServicesH2>Website type</ServicesH2>
          <ServicesP>Institutional website, e-commerce, or catalog?</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon2} />
          <ServicesH2>Website features</ServicesH2>
          <ServicesP>Institutional website, e-commerce, or catalog?</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon3} />
          <ServicesH2>OK! Ready to start</ServicesH2>
          <ServicesP>
            Contract, briefing, and we can start building your site!
          </ServicesP>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
